import React from "react";

export default class FixButton extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            value: this.props.value, 
            hovering: false,
        }
    }

    handleChange(event) {
        this.setState({value: event.target.value});
        if (this.props.onChange)
            this.props.onChange(event.target.value)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
          this.setState({value: this.props.value})
        }
      }

    render (){

        return ( 
            <button
                onClick={async () => {
                    this.props.callback();
                }}
                style={{ transition: 'all .3s', marginBottom: '10px', marginLeft: '5px', padding: '10px', backgroundColor: this.state.hovering ? '#C76815' : '#f58320', cursor: 'pointer', borderRadius: '5px', border: '0px', color: '#ffffff', boxShadow: this.state.hovering ? '0px 2px 5px darkgrey' : '0px 2px 5px lightgrey' }} 
                onMouseEnter={() => this.setState({ hovering: true })}
                onMouseLeave={() => this.setState({ hovering: false })} >            
              {this.props.title}
              </button>
        )
    }


}

const mainClass = {
    padding: '10px',
}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}